import * as Yup from "yup";

export const emailRecipientValidationShape = Yup.object().shape({
  firstName: Yup.string(),
  lastName: Yup.string(),
  email: Yup.string().email("Invalid email"),
  phoneNumber: Yup.string(),
  isAccountsRecipient: Yup.boolean(),
  isCommercialReportRecipient: Yup.boolean(),
  isComplianceReportRecipient: Yup.boolean(),
  isEnvdRecipient: Yup.boolean(),
});

export const emailRecipientsValidation: Yup.ArraySchema<
  Yup.SchemaOf<Omit<EmailRecipient, "id" | "source">>
> = Yup.array().nullable().of(emailRecipientValidationShape);

export const emailRecipientFormValidation = emailRecipientValidationShape.test({
  test: (values, { createError, options }) => {
    if (!values) return true;

    // Additional validation to check:
    // - 1. At least one field has some data
    //     While none of the fields are required individually, make sure at least one field has data in it.
    // - 2. Not a direct duplicate of another existing recipient
    //     Server will reject exact duplicates, but we want to prevent them from being entered in the first place.

    // 1. Validate at least one field has some data
    const { firstName, lastName, email, phoneNumber } = values;
    if (!(firstName || lastName || email || phoneNumber)) {
      return createError({
        path: "noInputs",
        message: "At least one field must be filled",
      });
    }

    // 2. Validate not a direct duplicate of another existing recipient

    // needs extra context of the Business.emailRecipients to check for duplicates
    const { context } = options;
    const { emailRecipients } = context;

    if (
      emailRecipients
        .filter((contact: EmailRecipient) => contact.id !== values.id)
        .some((contact: EmailRecipient) => {
          return (
            (values.email?.trim() || "") === (contact.email?.trim() || "") &&
            (values.firstName?.trim() || "") ===
              (contact.firstName?.trim() || "") &&
            (values.lastName?.trim() || "") ===
              (contact.lastName?.trim() || "") &&
            (values.phoneNumber?.trim() || "") ===
              (contact.phoneNumber?.trim() || "")
          );
        })
    ) {
      // There may be only data in one or any of the four input fields.
      // It doesn't make sense to show the error on an empty field,
      // so show the error under the first field with data actually in it.
      let errorField = "lastName"; // fallback
      if (values.email) {
        errorField = "email";
      } else if (values.phoneNumber) {
        errorField = "phoneNumber";
      } else if (values.firstName) {
        errorField = "firstName";
      }
      return createError({
        path: errorField,
        message: "This contact already exists",
      });
    }

    // we are all good!
    return true;
  },
});
